import "./FloatingContainer_module.css";
const FloatingContainer_module = {
    container: "container__354e11cb3f22ca80",
    content: "content__354e11cb3f22ca80",
    arrow: "arrow__354e11cb3f22ca80"
};
export { FloatingContainer_module as default };
